import { WrapperSection } from '@ldp-web/component-library/ui/atoms/section';
import { IComponentIdProps, TComponentStyling } from '@ldp/common-types';
import React, { FC } from 'react';

/** Wrapper component props */
export interface IWrapperComponentProps extends IComponentIdProps {
  /** children components under wrapper */
  children?: React.ReactNode;
  /** styling object for component */
  styling?: TComponentStyling;
  /** boolean for extra spacing */
  isExtraLargeSpacing?: boolean;
  /** boolean for no padding */
  isNoPadding?: boolean;
}

/** Wrapper for component that takes care of authored component styles */
export const WrapperComponent: FC<IWrapperComponentProps> = ({
  children,
  styling,
  isExtraLargeSpacing,
  isNoPadding,
  id,
  ...rest
}) => {
  return (
    <WrapperSection
      // @ts-ignore
      id={id}
      styling={styling}
      {...(isNoPadding && { px: 0 })}
      {...rest}
      shouldUseSpacingExtraLarge={isExtraLargeSpacing}
    >
      {children}
    </WrapperSection>
  );
};

export default WrapperComponent;
